// @flow

import { concat, and } from 'ramda'

export const getWebAppSubscriptionUrl = (baseUrl: string): string =>
  and(baseUrl, concat(baseUrl, '/account/subscriptions'))

export const getWebAppSignupUrl = (baseUrl: string): string =>
  and(baseUrl, concat(baseUrl, '/signup'))
